import {getElementById, hideElement, showElement} from './dom';

export function setupEntityLog(): void {
    document.querySelectorAll<HTMLElement>('.details_link').forEach((link) => {
        link.addEventListener('click', (event) => {
            event.preventDefault();
            const targetDivId = link.getAttribute('target_div');
            if (!targetDivId) {
                return;
            }
            const targetDiv = getElementById(targetDivId);
            if (!targetDiv) {
                return;
            }
            if (targetDiv.offsetParent !== null) {
                hideElement(targetDiv);
            } else {
                showElement(targetDiv);
            }
        });
    });
}
